import React from 'react';
import { ClickAwayListener } from '@mui/material';
import { Button } from '../Button/Button';
import css from './ConfirmationDialog.module.scss';

interface ConfirmationDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
}) => {
    if (!isOpen) return null;

    return (
        <div className={css.darkBackground}>
            <ClickAwayListener onClickAway={onClose}>
                <div className={css.confirmDialog}>
                    <div className={css.dialogHeader}>{title}</div>
                    <div className={css.dialogText}>{message}</div>
                    <div className={css.dialogButtonContainer}>
                        <Button variant="secondary" onClick={onClose}>
                            {cancelText}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                        >
                            {confirmText}
                        </Button>
                    </div>
                </div>
            </ClickAwayListener>
        </div>
    );
};
